import React from 'react';
import { Page, Layout, Card, List, Button } from '@shopify/polaris';
import { Helmet } from 'react-helmet';

class Help extends React.Component {

    state = {
    };

    render() {

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Help</title>
                </Helmet>
                <Page title="Help & Support"
                    subtitle="We are here to help and support you.">
                    <p>The best way to reach us to use our online messager showing at the bottom left of your screen.</p>
                    <Button onClick={() => { window.$crisp.push(["do", "chat:open"]); }}>Click to get support</Button>
                    <p>You can also reach us at <b>support@taggenieapp.com</b> or at our <a target="_new" href="https://www.facebook.com/taggenie/">Facebook page</a></p>
                    <p>Current app version is <b>v5.90</b></p>
                    <br></br>
                    <Layout>
                        <Layout.Section>
                            <Card title="Upcoming new fetures and improvements" sectioned>
                                <List type="bullet">
                                    <List.Item>Support for Order tagging</List.Item>
                                    <List.Item>Actions for adding tags based on attributes like status, catgory, etc.</List.Item>
                                    <List.Item>Weekly tag status report</List.Item>
                                </List>
                            </Card>
                            <Card title="Notable limitations" sectioned>
                                <List type="bullet">
                                    <List.Item>Weight conditions for Smart Collections are not supported and will be ignore when using Smart collection filter.</List.Item>
                                </List>
                            </Card>
                            <Card title="Version history">
                                 <Card.Section title="# Update 2026-03-09 (v5.90)">
                                    <List type="bullet">
                                        <List.Item>Added "Update Product Metafield From Tag Mapping" rule to be able update a metafield based on specific tags.</List.Item>
                                        </List>
                                </Card.Section>
                                <Card.Section title="# Update 2026-02-16 (v5.82)">
                                    <List type="bullet">
                                        <List.Item>Added "Tag Products When Multiple Tags Exist" rule to be able to add a tag based on the existance or non-existance of other tags.</List.Item>
                                        <List.Item>Added the ability to see all product that have a particular Option Value on the Add Option Name As Variant Metafield Using Mapping Table rule</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2023-12-23 (v5.81)">
                                    <List type="bullet">
                                        <List.Item>Added "Products with No Tags" checkbox to Tag Explorer to allow display of items without any tags</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2023-07-07 (v5.80)">
                                    <List type="bullet">
                                        <List.Item>Added Ignore capabilities to our Tag Rules so that order, products, or customers can be excluded from being processed by rules.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2023-02-24 (v5.78)">
                                    <List type="bullet">
                                        <List.Item>Added new rule - autoTagOrdersByLocationRule</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2023-02-21 (v5.77)">
                                    <List type="bullet">
                                        <List.Item>Added new rule - AutoTagOrdersByVendorRule</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2023-02-17 (v5.76)">
                                    <List type="bullet">
                                        <List.Item>Added the capability to tag customers by product ids</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2023-02-11 (v5.75)">
                                    <List type="bullet">
                                        <List.Item>Added new tag operation for fixing/changing tag capitalization.</List.Item>
                                        <List.Item>Added new tag operation for replacing symbols and text in tags.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2023-01-05 (v5.71)">
                                    <List type="bullet">
                                        <List.Item>Introduced suggestions for duplicate product tags on the dashboard.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2023-01-05 (v5.70)">
                                    <List type="bullet">
                                        <List.Item>New Tag Rule to enable automatically tagging customers by purchased products</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2023-01-02 (v5.61)">
                                    <List type="bullet">
                                        <List.Item>Added new Tag Rule for AutoTagProductByStatus to allow auto tagging by product status.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2022-12-01 (v5.60)">
                                    <List type="bullet">
                                        <List.Item>Introduced Tag Explorer</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2022-10-08 (v5.56)">
                                    <List type="bullet">
                                        <List.Item>Added new rule "Auto Tag Products By Variant Option" that enables tags to be automatically added based on selected options like Size, Color, etc.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2022-10-05 (v5.55)">
                                    <List type="bullet">
                                        <List.Item>Added new rule "Update Product Metafield From Variant Options"</List.Item>
                                        <List.Item>Added new rule "Update Variant Metafield From Variant Options"</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2022-07-29 (v5.50)">
                                    <List type="bullet">
                                        <List.Item>Added support for orders</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2022-06-18 (v5.14)">
                                    <List type="bullet">
                                        <List.Item>Added the option to replace spaces with hypens to rules: AutoTagProductByVendor, AutoTagProductByType</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2022-05-17 (v5.13)">
                                    <List type="bullet">
                                        <List.Item>New Tag Rule - Add Option Name As Variant Metafield Rule</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2022-04-29 (v5.12)">
                                    <List type="bullet">
                                        <List.Item>Tag Groups can now be edited - rename, change tags, etc.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2022-04-28 (v5.11)">
                                    <List type="bullet">
                                        <List.Item>New Tag Rule - Auto-Tag Products On Sale</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2022-04-19 (v5.10)">
                                    <List type="bullet">
                                        <List.Item>New Tag Rule - Auto-Tag by Product Type</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2022-04-11 (v5.01)">
                                    <List type="bullet">
                                        <List.Item>Merge tags scenario can now use tag templates</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2022-04-03 (v5.00)">
                                    <List type="bullet">
                                        <List.Item>Introduce Tag Rules</List.Item>
                                        <List.Item>Added auto-tag by product vendor rule</List.Item>
                                        <List.Item>Added auto-tag when product is crerated rule</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2022-02-20 (v4.11)">
                                    <List type="bullet">
                                        <List.Item>Fixed issue with product status filter</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2022-02-10 (v4.1)">
                                    <List type="bullet">
                                        <List.Item>Introduced Tag Groups which are replacement for Validation rules</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2022-01-31 (v4.0)">
                                    <List type="bullet">
                                        <List.Item>Major version update introducing customer tags</List.Item>
                                        <List.Item>Introduced a new UI layout for custom tag operations - Customers only for now</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-12-01 (v3.8)">
                                    <List type="bullet">
                                        <List.Item>Added new tag action to allow adding new tags based on existing tags</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-11-07 (v3.7)">
                                    <List type="bullet">
                                        <List.Item>Added new messenger to improve support</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-10-18 (v3.6)">
                                    <List type="bullet">
                                        <List.Item>Introduced separate screens for managing automations</List.Item>
                                        <List.Item>New "Time since product creationg" condition</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-10-08 (v3.51)">
                                    <List type="bullet">
                                        <List.Item>Fixed an issue with editing tags with special character - $, ", \, etc.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-09-13 (v3.50)">
                                    <List type="bullet">
                                        <List.Item>Decreased tag operation execution times by about 50%</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-08-26 (v3.44)">
                                    <List type="bullet">
                                        <List.Item>{"Added new tag rename template {{tag_name-capitalized-first}} - to enable capitalizing the first word of a tag"}</List.Item>
                                        <List.Item>{"Added new tag rename template {{tag_name-capitalized-all}} - to enable capitalizing all words of a tag"}</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-08-21 (v3.43)">
                                    <List type="bullet">
                                        <List.Item>Added new automation frequencies - every day, every week, every month</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-08-08 (v3.42)">
                                    <List type="bullet">
                                        <List.Item>Added new condition (Price percentage of Compare at Price) to allow filtering on products based on the percentage of price against compare at price.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-08-03 (v3.41)">
                                    <List type="bullet">
                                        <List.Item>Added an option to display rarely-used tags to help with spotting old/unused tags.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-06-28 (v3.40)">
                                    <List type="bullet">
                                        <List.Item>Support for filtering based on Smart collections</List.Item>
                                        <List.Item>New automation type - execute operations at a specific date & time.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-06-24 (v3.35)">
                                    <List type="bullet">
                                        <List.Item>Display products per tag - clicking on a tag on the dashboard will show all products that have the respective tag.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-06-09 (v3.30)">
                                    <List type="bullet">
                                        <List.Item>Added filter for Compare at price to allow filtering on Compare at price</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-05-11 (v3.20)">
                                    <List type="bullet">
                                        <List.Item>Operations can now be edited - conditions and actions of existing operations can now be changed</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-04-12 (v3.13)">
                                    <List type="bullet">
                                        <List.Item>Preview screen now displays images of products</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-04-08 (v3.12)">
                                    <List type="bullet">
                                        <List.Item>Moved all videos to a new page called Tutorials</List.Item>
                                        <List.Item>Added new product status filter to enable filtering on statuses - Active, Draft, Archived </List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-04-05 (v3.11)">
                                    <List type="bullet">
                                        <List.Item>Fixed an issue with Merge Tags where target tag was in the source tags list.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-03-30 (v3.1)">
                                    <List type="bullet">
                                        <List.Item>Added templated rename functionality to allow advaced renaming like adding suffixes or prefixes to tags</List.Item>
                                        <List.Item>Show statistics on tag changes and time saved</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-03-28 (v3.00)">
                                    <List type="bullet">
                                        <List.Item>Tag Genie now opens in a new tab so that more screen realstate is available</List.Item>
                                        <List.Item>Created a separate Development plan for dev stores</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-03-03 (v2.62)">
                                    <List type="bullet">
                                        <List.Item>Added Product updated at filter</List.Item>
                                        <List.Item>Added Product created at filter</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-02-27 (v2.61)">
                                    <List type="bullet">
                                        <List.Item>Operations screen - added search by operation description</List.Item>
                                        <List.Item>Operations screen - added tab for operations with automations</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-02-21 (v2.6)">
                                    <List type="bullet">
                                        <List.Item>Overhaul of Custom Tag Operation screen</List.Item>
                                        <List.Item>Custom tag operations now allow multiple tag actions to be defined - remove, add, rename</List.Item>
                                        <List.Item>Overhaul of preview screen - added additional information and improved UI</List.Item>
                                        <List.Item>Added Product Type condition filter</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-02-10">
                                    <List type="bullet">
                                        <List.Item>Added "Varian title" filter to allow filtering by variant title.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-02-10">
                                    <List type="bullet">
                                        <List.Item>Added "Varian title" filter to allow filtering by variant title.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-02-07">
                                    <List type="bullet">
                                        <List.Item>Fixed an issue with "Varian option" filter where first value selected caused an error.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-01-16">
                                    <List type="bullet">
                                        <List.Item>Tags can be exported from Dashboard to CSV</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-01-15">
                                    <List type="bullet">
                                        <List.Item>Introduced Scenarios - easily execute common tag operations</List.Item>
                                        <List.Item>New Scenarios - Bulk Remove Tags, Merge Tags</List.Item>
                                        <List.Item>Filterting added to tags on dashboard</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2021-01-02">
                                    <List type="bullet">
                                        <List.Item>Store product updates are now reflected in the app in a matter of seconds.</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2020-11-28">
                                    <List type="bullet">
                                        <List.Item>Introduce action credits</List.Item>
                                        <List.Item>Support for dev stores - they can now use all features automatically</List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2020-11-26">
                                    <List type="bullet">
                                        <List.Item>Added the ability to choose AND or OR logical operator for filter conditions. </List.Item>
                                    </List>
                                </Card.Section>
                                <Card.Section title="# Update 2020-11-23">
                                    <List type="bullet">
                                        <List.Item>Introduce GreaterThanOrEqual and LessThanOrEqual conditions to price filter</List.Item>
                                        <List.Item>Introduce GreaterThanOrEqual and LessThanOrEqual conditions to inventory quantity filter</List.Item>
                                    </List>
                                </Card.Section>
                            </Card>
                        </Layout.Section>
                    </Layout>
                </Page>
            </div>
        );
    }

    onFacebookClick = () => {

    }

    componentDidMount() {

    }
}

export default Help;